import { ToolkitCard } from "@arcadeai/design-system/components/ui/molecules/toolkit-card";
import { getToolkitIcon } from "@arcadeai/design-system/metadata/toolkit-icons";
import type { ProcessedToolkit } from "@/clients/arcade/arcade";

export type ToolkitCardWithSelectionProps = {
  toolkit: ProcessedToolkit;
  selectedTools: Set<string>;
  onSelect: (checked: boolean) => void;
  onView: () => void;
  selectionMode: "single" | "multi";
};

export function ToolkitCardWithSelection({
  toolkit,
  selectedTools,
  onSelect,
  onView,
  selectionMode,
}: ToolkitCardWithSelectionProps) {
  // Calculate selection state
  const selectedToolsInThisToolkit = toolkit.tools.filter((tool) =>
    selectedTools.has(tool.fully_qualified_name)
  );
  const selectedToolsCount = selectedToolsInThisToolkit.length;
  const isSelected = selectedToolsCount === toolkit.tools.length;
  const isPartiallySelected =
    selectedToolsCount > 0 && selectedToolsCount < toolkit.tools.length;

  return (
    <ToolkitCard
      data-testid={`toolkit-card-${toolkit.name}`}
      description={toolkit.description}
      hideCheckbox={selectionMode === "single"}
      Icon={getToolkitIcon(toolkit.metadata?.id)}
      isByoc={toolkit.metadata?.isBYOC ?? false}
      isPartiallySelected={isPartiallySelected}
      isPro={toolkit.metadata?.isPro ?? false}
      isSelected={isSelected}
      name={toolkit.name}
      onSelect={onSelect}
      onView={onView}
      requirementsSummary={toolkit.requirementsSummary}
      selectedToolsCount={selectedToolsCount}
      toolsCount={toolkit.tools.length}
    />
  );
}
